import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  list: {
    padding: 0,
    margin: 5,
    borderRadius: 8
  },
  textField: {
    '& .MuiFormHelperText-root': {
      textAlign: 'right'
    },
    '& textarea': {
      paddingRight: 30
    }
  },
  item: {
    // color: theme.palette.text.secondary,
    // marginBottom: 16,
    // padding: '8px 16px',
    // borderRadius: 4,
    // alignItems: 'flex-start',
    // border: `1px solid ${theme.palette.divider}`,
    // '& .MuiListItemIcon-root': {
    //   minWidth: 20
    // }
  }
}));
